export default "__VITE_ASSET__b0040a5d__"